import { styled } from "goober";

export const FullSizeModalContent = styled("div")`
  width: 80vw;
  max-width: 1200px;
  height: 80vh;
  max-height: 800px;
  display: flex;
  flex-direction: column;
`;

export const FullSizeModalHeader = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
`;

export const FullSizeModalHeaderIcon = styled("div")`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--alpha4);
  border-radius: 8px;
`;

export const FullSizeModalHeaderActions = styled("div")`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
`;
